import React, { useState } from 'react';
import { Card, CardBody, CardTitle, Col, Container, Row } from 'reactstrap';
import Breadcrumb from 'Components/Common/Breadcrumb';
import tamga from '../../../assets/images/tamga.png'
import * as html2pdf from 'html2pdf.js';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

const ReportBox2_3 = () => {

  const [a18Value, setA18Value] = useState('');
  const [a19Value, setA19Value] = useState('');
  const [a20Value, setA20Value] = useState('');
  const [a21Value, setA21Value] = useState('');
  const [a22Value, setA22Value] = useState('');
  const [a23Value, setA23Value] = useState('');
  const [a24Value, setA24Value] = useState('');

  const [c18Value, setC18Value] = useState('');
  const [c19Value, setC19Value] = useState('');
  const [c20Value, setC20Value] = useState('');
  const [c21Value, setC21Value] = useState('');
  const [c22Value, setC22Value] = useState('');
  const [c23Value, setC23Value] = useState('');
  const [c24Value, setC24Value] = useState('');

  const [d18Value, setD18Value] = useState('');
  const [d19Value, setD19Value] = useState('');
  const [d20Value, setD20Value] = useState('');
  const [d21Value, setD21Value] = useState('');
  const [d22Value, setD22Value] = useState('');
  const [d23Value, setD23Value] = useState('');
  const [d24Value, setD24Value] = useState('');

  const [e18Value, setE18Value] = useState('');
  const [e19Value, setE19Value] = useState('');
  const [e20Value, setE20Value] = useState('');
  const [e21Value, setE21Value] = useState('');
  const [e22Value, setE22Value] = useState('');
  const [e23Value, setE23Value] = useState('');
  const [e24Value, setE24Value] = useState('');

  const [g18Value, setG18Value] = useState('');
  const [g19Value, setG19Value] = useState('');
  const [g20Value, setG20Value] = useState('');
  const [g21Value, setG21Value] = useState('');
  const [g22Value, setG22Value] = useState('');
  const [g23Value, setG23Value] = useState('');
  const [g24Value, setG24Value] = useState('');

  const [h18Value, setH18Value] = useState('');
  const [h19Value, setH19Value] = useState('');
  const [h20Value, setH20Value] = useState('');
  const [h21Value, setH21Value] = useState('');
  const [h22Value, setH22Value] = useState('');
  const [h23Value, setH23Value] = useState('');
  const [h24Value, setH24Value] = useState('');

  const [i18Value, setI18Value] = useState('');
  const [i19Value, setI19Value] = useState('');
  const [i20Value, setI20Value] = useState('');
  const [i21Value, setI21Value] = useState('');
  const [i22Value, setI22Value] = useState('');
  const [i23Value, setI23Value] = useState('');
  const [i24Value, setI24Value] = useState('');

  const [j18Value, setJ18Value] = useState('');
  const [j19Value, setJ19Value] = useState('');
  const [j20Value, setJ20Value] = useState('');
  const [j21Value, setJ21Value] = useState('');
  const [j22Value, setJ22Value] = useState('');
  const [j23Value, setJ23Value] = useState('');
  const [j24Value, setJ24Value] = useState('');

  const handleFileRead = async () => {
    const response = await fetch('/report/Report_BOX_2_3.xlsx');
    const arrayBuffer = await response.arrayBuffer();
    const workbook = new ExcelJS.Workbook();
    await workbook.xlsx.load(arrayBuffer);
    const worksheet = workbook.getWorksheet('З-БOX-2.3');

    if (worksheet) {

      worksheet.getCell('A18').value = a18Value;
      worksheet.getCell('A19').value = a19Value;
      worksheet.getCell('A20').value = a20Value;
      worksheet.getCell('A21').value = a21Value;
      worksheet.getCell('A22').value = a22Value;
      worksheet.getCell('A23').value = a23Value;
      worksheet.getCell('A24').value = a24Value;

      worksheet.getCell('C18').value = c18Value;
      worksheet.getCell('C19').value = c19Value;
      worksheet.getCell('C20').value = c20Value;
      worksheet.getCell('C21').value = c21Value;
      worksheet.getCell('C22').value = c22Value;
      worksheet.getCell('C23').value = c23Value;
      worksheet.getCell('C24').value = c24Value;

      worksheet.getCell('D18').value = d18Value;
      worksheet.getCell('D19').value = d19Value;
      worksheet.getCell('D20').value = d20Value;
      worksheet.getCell('D21').value = d21Value;
      worksheet.getCell('D22').value = d22Value;
      worksheet.getCell('D23').value = d23Value;
      worksheet.getCell('D24').value = d24Value;

      worksheet.getCell('E18').value = e18Value;
      worksheet.getCell('E19').value = e19Value;
      worksheet.getCell('E20').value = e20Value;
      worksheet.getCell('E21').value = e21Value;
      worksheet.getCell('E22').value = e22Value;
      worksheet.getCell('E23').value = e23Value;
      worksheet.getCell('E24').value = e24Value;

      worksheet.getCell('G18').value = g18Value;
      worksheet.getCell('G19').value = g19Value;
      worksheet.getCell('G20').value = g20Value;
      worksheet.getCell('G21').value = g21Value;
      worksheet.getCell('G22').value = g22Value;
      worksheet.getCell('G23').value = g23Value;
      worksheet.getCell('G24').value = g24Value;

      worksheet.getCell('H18').value = h18Value;
      worksheet.getCell('H19').value = h19Value;
      worksheet.getCell('H20').value = h20Value;
      worksheet.getCell('H21').value = h21Value;
      worksheet.getCell('H22').value = h22Value;
      worksheet.getCell('H23').value = h23Value;
      worksheet.getCell('H24').value = h24Value;

      worksheet.getCell('I18').value = i18Value;
      worksheet.getCell('I19').value = i19Value;
      worksheet.getCell('I20').value = i20Value;
      worksheet.getCell('I21').value = i21Value;
      worksheet.getCell('I22').value = i22Value;
      worksheet.getCell('I23').value = i23Value;
      worksheet.getCell('I24').value = i24Value;

      worksheet.getCell('J18').value = j18Value;
      worksheet.getCell('J19').value = j19Value;
      worksheet.getCell('J20').value = j20Value;
      worksheet.getCell('J21').value = j21Value;
      worksheet.getCell('J22').value = j22Value;
      worksheet.getCell('J23').value = j23Value;
      worksheet.getCell('J24').value = j24Value;



      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/octet-stream' });
      saveAs(blob, 'Report_BOX_2_3.xlsx');
    } else {
      console.error('Worksheet not found');
    }
  };


  const exportToPDF = () => {
    // PDF рүү экспортлохыг хүсэж буй HTML элементийг олж авна
    const element = document.getElementById('exportable-content');

    if (element) {
      const opt = {
        margin: 0.5,
        filename: 'Бох-2_3-тайлан.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 5, useCORS: true, logging: true },
        jsPDF: { unit: 'cm', format: 'a4', orientation: 'p' }
      };

      // html2pdf ашиглан PDF болгон хувиргана
      html2pdf().from(element).set(opt).save();
    } else {
      console.error('Element not found!');
    }
  };
  document.title = "БОХ-2.3 маягт. Усны чанар төлөв байдлын 20... жилийн мэдээ ";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Тайлан" breadcrumbItem="БОХ-2.3 маягт" />
          <div className="d-flex flex-column mx-auto reportBox" style={{ width: '800px' }}>
            <Card>
              <CardBody className="border-bottom">
                <div id="exportable-content">
                  <Row>
                    <div className="d-flex align-content-between ">
                      <img className="tamga" src={tamga} alt="" />
                      <Col lg={6}>
                        <p style={{ textAlign: 'justify', width: '350px', fontSize: '10px' }}>
                          Үндэсний статистикийн хорооны даргын 2019 оын А/134 дүгээр тушаалаар зөвшөөрснөөр, Байгаль орчин, аялал жуулчлалын сайдын 2019 оны 09 сарын 19 - ны өдрийн А/527 дугаар тушаалаар батлав.
                        </p>
                      </Col>
                      <Col lg={6}>
                        <p style={{ textAlign: 'right', fontSize: '10px' }}>З-БОХ-2.3</p>
                      </Col>
                    </div>
                  </Row>
                  <Row>
                    <CardTitle className="text-center text-uppercase" style={{ fontSize: '12px' }}> Усны чанарын төлөв байдлын 2024 оны жилийн мэдээ </CardTitle>
                  </Row>
                  <Row>
                    <CardTitle className=" text-uppercase" style={{ fontSize: '12px' }}> 1. Хаягийн хэсэг </CardTitle>
                  </Row>
                  <Row>
                    <Col lg={5}>
                      <div>
                        <table className="table table-bordered border-dark tableTopLeftCenter">
                          <thead>
                            <tr>
                              <th style={{ width: '200px', padding: '0' }}> Байршил </th>
                              <th style={{ width: '250px', padding: '0' }}> Нэр </th>
                              <th style={{ width: '100px', padding: '0' }}> Код </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td style={{ padding: '0' }}>Аймаг, нийслэл</td>
                              <td style={{ padding: '0' }}>  </td>
                              <td style={{ padding: '0' }}>  </td>
                            </tr>
                            <tr>
                              <td style={{ padding: '0' }}> Сум, дүүрэг </td>
                              <td style={{ padding: '0' }}>  </td>
                              <td style={{ padding: '0' }}>  </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </Col>
                    <Col lg={7}>
                      <p style={{ textAlign: 'justify', fontSize: '10px' }} className="p-0 m-0">
                        1. Байгаль орчин, хэмжил зүйн төв лаборатори нь дараа оны 3 дуггаар сарын 01-ны дотор Байгаль орчны мэдээллийн төвд цахимаар ирүүлнэ.
                      </p>
                      <p style={{ textAlign: 'justify', fontSize: '10px' }} className="p-0 m-0">
                        2. Байгаль орчны мэдээллийн төв нь 3 дугаар сарын 10-ны дотор Байгаль орчны асуудал эрхэлсэн төрийн захиргааны төв байгууллагад цахимаар болон маягтаар ирүүлнэ.
                      </p>
                      <p style={{ textAlign: 'justify', fontSize: '10px' }} className="p-0 m-0">
                        3. Байгаль орчны асуудал эрхэлсэн төрийн захиргааны төв байгууллага нь мэдээг хянаж нэгтгээд 3 дугаар сарын 20-ны Үндэсний статистикийн хороонд цахим болон маягтаар ирүүлнэ.
                      </p>
                    </Col>
                  </Row>
                  <Row>
                    <CardTitle className=" text-uppercase" style={{ fontSize: '12px' }}> 2. Үндсэн үзүүлэлт </CardTitle>
                  </Row>
                  <Row>
                    <Col lg={12}>
                      <div className="table-responsive">
                        <table className="table table-bordered border-dark tableTopLeftCenter" style={{ borderCollapse: 'collapse' }}>
                          <thead>
                            <tr style={{ borderBottom: 'unset' }}>
                              <th rowSpan={2}>Харуулын нэр</th>
                              <th rowSpan={2}>МД</th>
                              <th rowSpan={2}>Цахилгаан дамжуулан чанар ЕС µS/cm</th>
                              <th rowSpan={1} colSpan={5}> Ус бохирдуулах бодисын жилийн дундаж агууламж, мг/л </th>
                              <th rowSpan={2}>Усны чанарын индекс</th>
                            </tr>
                            <tr style={{ borderTop: 'unset' }}>
                              <th>
                                Ууссан хүчилтөрөгч (О2)
                              </th>
                              <th>
                                Биохимийн  хэрэгцээт хүчилтөрөгч (БХХ5)
                              </th>
                              <th>
                                Перманганатын исэлдэх чанар (ПИЧ)
                              </th>
                              <th>
                                Аммонийн азот (NH4-N)
                              </th>
                              <th>
                                Эрдэс фосфор (Pэрд)
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>A</td>
                              <td>Б</td>
                              <td>1</td>
                              <td>2</td>
                              <td>3</td>
                              <td>4</td>
                              <td>5</td>
                              <td>6</td>
                              <td>7</td>
                            </tr>
                            <tr>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={a18Value}
                                  onChange={(e) => setA18Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>1</td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={c18Value}
                                  onChange={(e) => setC18Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={d18Value}
                                  onChange={(e) => setD18Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={e18Value}
                                  onChange={(e) => setE18Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={g18Value}
                                  onChange={(e) => setG18Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={h18Value}
                                  onChange={(e) => setH18Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={i18Value}
                                  onChange={(e) => setI18Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={i18Value}
                                  onChange={(e) => setJ18Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={a19Value}
                                  onChange={(e) => setA19Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>2</td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={c19Value}
                                  onChange={(e) => setC19Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={d19Value}
                                  onChange={(e) => setD19Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={e19Value}
                                  onChange={(e) => setE19Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={g19Value}
                                  onChange={(e) => setG19Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={h19Value}
                                  onChange={(e) => setH19Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={i19Value}
                                  onChange={(e) => setI19Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={j19Value}
                                  onChange={(e) => setJ19Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={a20Value}
                                  onChange={(e) => setA20Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>3</td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={c20Value}
                                  onChange={(e) => setC20Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={d20Value}
                                  onChange={(e) => setD20Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={e20Value}
                                  onChange={(e) => setE20Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={g20Value}
                                  onChange={(e) => setG20Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={h20Value}
                                  onChange={(e) => setH20Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={i20Value}
                                  onChange={(e) => setI20Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={j20Value}
                                  onChange={(e) => setJ20Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={a21Value}
                                  onChange={(e) => setA21Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>4</td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={c21Value}
                                  onChange={(e) => setC21Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={d21Value}
                                  onChange={(e) => setD21Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={e21Value}
                                  onChange={(e) => setE21Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={g21Value}
                                  onChange={(e) => setG21Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={h21Value}
                                  onChange={(e) => setH21Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={i21Value}
                                  onChange={(e) => setI21Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={j21Value}
                                  onChange={(e) => setJ21Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={a22Value}
                                  onChange={(e) => setA22Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>5</td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={c22Value}
                                  onChange={(e) => setC22Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={d22Value}
                                  onChange={(e) => setD22Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={e22Value}
                                  onChange={(e) => setE22Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={g22Value}
                                  onChange={(e) => setG22Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={h22Value}
                                  onChange={(e) => setH22Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={i22Value}
                                  onChange={(e) => setI22Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={j22Value}
                                  onChange={(e) => setJ22Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={a23Value}
                                  onChange={(e) => setA23Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>6</td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={c23Value}
                                  onChange={(e) => setC23Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={d23Value}
                                  onChange={(e) => setD23Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={e23Value}
                                  onChange={(e) => setE23Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={g23Value}
                                  onChange={(e) => setG23Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={h23Value}
                                  onChange={(e) => setH23Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={i23Value}
                                  onChange={(e) => setI23Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={j23Value}
                                  onChange={(e) => setJ23Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={a24Value}
                                  onChange={(e) => setA24Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>7</td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={c24Value}
                                  onChange={(e) => setC24Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={d24Value}
                                  onChange={(e) => setD24Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={e24Value}
                                  onChange={(e) => setE24Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={g24Value}
                                  onChange={(e) => setG24Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={h24Value}
                                  onChange={(e) => setH24Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={i24Value}
                                  onChange={(e) => setI24Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={j24Value}
                                  onChange={(e) => setJ24Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                    </Col>
                  </Row>
                </div>
                <Row>
                  <Col className="d-flex justify-content-evenly">
                    <button onClick={exportToPDF}
                      type="button"
                      className="btn btn-primary  btn-label"
                    >
                      <i className="mdi mdi-download label-icon"></i>{" "}
                      PDF Татах
                    </button>

                    <button onClick={handleFileRead}
                      type="button"
                      className="btn btn-success  btn-label"
                    >
                      <i className="mdi mdi-download label-icon"></i>{" "}
                      Excel Татах
                    </button>

                  </Col>
                </Row>
              </CardBody>
            </Card>
          </div>
        </Container>
      </div>
    </React.Fragment >
  );
}

export default ReportBox2_3;